<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">{{ (isNew ? 'department.teamEdit.titleAdd' : 'department.teamEdit.titleEdit') | translate }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup">

        <div class="mb-3">
          <label for="name" class="form-label">{{ 'department.teamEdit.nameLabel' | translate }}</label>
          <input type="text" class="form-control" id="name" maxlength="100" formControlName="name"
            [placeholder]="'department.teamEdit.namePlaceholder' | translate">
          <field-error-component [field]="'name'" [label]="'department.teamEdit.nameFieldLabel' | translate"
            [formGroup]="formGroup"></field-error-component>
        </div>

        <div class="mb-3">
          <label class="fw-medium">{{ 'department.teamEdit.supervisorsLabel' | translate }}</label>
          <mat-select class="form-control" formControlName="supervisors" multiple [placeholder]="'department.teamEdit.select' | translate"
            [compareWith]="compareWithObjectBase">
            <div class="p-2 mb-2">
              <input class="form-control" type="text" (focus)="onFocusSupervisors()"
                [formControl]="filterControlSupervisors" [placeholder]="'department.teamEdit.searchDepartmentPlaceholder' | translate">
            </div>
            @for (item of listSupervisors; track item) {
            <mat-option [value]="item">{{item.name}}</mat-option>
            }
          </mat-select>
          <field-error-component [field]="'supervisors'" [label]="'department.teamEdit.supervisorFieldLabel' | translate"
            [formGroup]="formGroup"></field-error-component>
        </div>

        <div class="mb-3">
          <label class="fw-medium">{{ 'department.teamEdit.agentLabel' | translate }}</label>
          <mat-select class="form-control" formControlName="agents" multiple [placeholder]="'department.teamEdit.select' | translate"
            [compareWith]="compareWithObjectBase">
            <div class="p-2 mb-2">
              <input class="form-control" type="text" (focus)="onFocusAgents()"
                [formControl]="filterControlAgents" [placeholder]="'department.teamEdit.searchUserPlaceholder' | translate">
            </div>
            @for (item of listAgents; track item) {
            <mat-option [value]="item">{{item.name}}</mat-option>
            }
          </mat-select>
          <field-error-component [field]="'agents'" [label]="'department.teamEdit.agentFieldLabel' | translate"
            [formGroup]="formGroup"></field-error-component>
        </div>

      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'department.teamEdit.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid"
        (click)="save()"
      >
        {{ (isNew ? 'department.teamEdit.save' : 'department.teamEdit.update') | translate }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>

  </div>
</div>
